import { useDispatch, useSelector } from "react-redux";

import { IRootState } from "../../../state";
import { ILocationContentfulData } from "../../../services/contentful-service/contentful.interface";
import { setContentfulDataActions } from "../../../state/contentfulData";
import { createDate } from "../../../utils/date";

const useContentfulDataStore = () => {
  const dispatch = useDispatch();

  const contentfulData = useSelector((state: IRootState) => state.contentfulData);

  const setContentfulData = (data: ILocationContentfulData | null) => {
    dispatch(setContentfulDataActions.setContentfulDataAction(data));
  };

  const checkIsHospitalOpen = (data: ILocationContentfulData) => {
    const hospitalData = data.fields;
    let isHospitalOpen = true;

    if (hospitalData.openingDay && hospitalData.openingMonth && hospitalData.openingYear) {
      const openingHospitalDate = createDate(hospitalData.openingDay as number,
        hospitalData.openingMonth as number, hospitalData.openingYear as number);

      if (new Date().getTime() <= new Date(openingHospitalDate).getTime()) {
        isHospitalOpen=false;
      }
    }

    return isHospitalOpen;
  };


  return {
    setContentfulData,
    contentfulData: contentfulData,
    isHospitalOpen: contentfulData && checkIsHospitalOpen(contentfulData),
  };
};

export default useContentfulDataStore;
